import styled from 'styled-components';
import { DEVICES } from '_constants';
import { CLOSE_MODAL_ICON } from 'assets/icons';

export const Overlay = styled.div`
  position: fixed;
  top: ${({ topOffset }) => topOffset}px;
  left: ${({ leftOffset }) => leftOffset || 0}px;
  right: 0;
  bottom: 0;
  z-index: 9000;
  background: var(--dark30);
  opacity: ${({ state, disableAnimation }) => (disableAnimation || state === 'entered' ? 1 : 0)};
  transition: ${({ disableAnimation }) => (disableAnimation ? 'none' : 'opacity 300ms ease')};
`;

export const Panel = styled.div`
  position: fixed;
  top: ${({ topOffset }) => topOffset}px;
  ${({ side, leftOffset }) => (side === 'left' ? `left: ${leftOffset || 0}px;` : 'right: 0;')}
  bottom: 0;
  z-index: 9001;
  width: 440px;
  max-width: 100vw;
  background-color: var(--white);
  box-shadow: ${({ side }) => (side === 'left' ? '4px 0 16px rgba(0, 0, 0, 0.12)' : '-4px 0 16px rgba(0, 0, 0, 0.12)')};
  display: flex;
  flex-direction: column;
  transform: translateX(
    ${({ state, side, disableAnimation }) => {
      if (disableAnimation || state === 'entered') return '0';
      return side === 'left' ? '-100%' : '100%';
    }}
  );
  transition: ${({ disableAnimation }) => (disableAnimation ? 'none' : 'transform 300ms ease')};

  @media ${DEVICES.mobileXL} {
    width: 100vw;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid var(--dark10, #e5e5e5);
  flex-shrink: 0;
`;

export const HeaderText = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: var(--text-strong);
`;

export const Subtitle = styled.div`
  font-size: 12px;
  /* Muted supporting line under the drawer title — #6b6b6b and --dim-grey are both mid grey. */
  color: var(--dim-grey);
  line-height: 1.4;
`;

export const CloseButton = styled.button`
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  cursor: pointer;
  background: transparent url(${CLOSE_MODAL_ICON}) no-repeat center center;
  background-size: 16px 16px;
`;

export const Content = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px 24px;
`;

export const Footer = styled.div`
  flex-shrink: 0;
`;
